import { useNavigate } from "react-router-dom";
import { AuthLayout } from "../auth/AuthLayout";
import { Button, Callout } from "@/design/components";
import authStyles from "../auth/AuthForm.module.css";

/**
 * Where Stripe Checkout returns the admin: `/billing/success` (paid) or
 * `/billing/cancel` (abandoned). The org's tier is reconciled by the billing
 * webhook, so success just reassures + routes back into the portal.
 */
export function BillingReturnScreen({ mode }: { mode: "success" | "cancel" }) {
  const navigate = useNavigate();
  const success = mode === "success";
  return (
    <AuthLayout>
      <header className={authStyles.head}>
        <p className="u-eyebrow">Billing</p>
        <h2 className={authStyles.title}>{success ? "Payment received" : "Checkout canceled"}</h2>
      </header>

      <Callout tone={success ? "success" : "info"} title={success ? "Thanks for subscribing" : "No charge was made"}>
        {success
          ? "Your plan updates as soon as Stripe confirms the payment — usually within a few seconds."
          : "You can pick a plan and try again whenever you're ready."}
      </Callout>

      <Button size="lg" fullWidth onClick={() => navigate("/app/billing", { replace: true })}>
        Back to billing
      </Button>
    </AuthLayout>
  );
}
